import Vue from 'vue'
import Vuex from 'vuex'
import { ApiSiroleg } from '../libs/api-siroleg'
import { SSO } from '../libs/sso'

import dataWilayah from './dataWilayah.js'

Vue.use(Vuex)

// now we grab variable
export default new Vuex.Store({
	// modules
	modules: {
		dataWilayah
	},

	// state (root)
    state: {
        userInfo: null, // user info dari sso
        busy: false,    // status layar (busy) bakal mnculin modal

        // backend Siroleg
        api: new ApiSiroleg(process.env.API_URL, process.env.API_TIMEOUT),

		// SSO library
        sso: new SSO('6', /* process.env.NODE_ENV == 'production' */false),

        sidebarActive: false,
		mobileScreen: false,

		scrollToElement: null
    },
    mutations: {
        setSidebarActive(state, payload) {
            state.sidebarActive = payload
        },
		setMobileScreen(state, payload) {
			state.mobileScreen = payload
		},
        setUserInfo(state, payload) {
            state.userInfo = payload
        },
        setBusyState(state, payload) {
            state.busy = payload
            // log it?
            console.log("BUSY? " + state.busy)
        },
		setScrollToElement(state, payload) {
			state.scrollToElement = payload
		}
    },
    getters: {
        sidebar: (state) => (state.sidebarActive),
		mobileScreen: (state) => (state.mobileScreen),
        api: state => (state.api),
        sso: state => (state.sso),

		userData: state => {
			const userInfo = state.userInfo

			var defaultData = {
				nama: '<ANYONYMOUS>',
				nip: '-',
				group: '???'
			}

			if (!userInfo) return defaultData

			// build data
			defaultData.nama = userInfo.detil.nama ? userInfo.detil.nama : '<NO NAME>'
			defaultData.nip = userInfo.detil.nip ? userInfo.detil.nip : '-'
			defaultData.group = userInfo.group || '???'
			defaultData.status = userInfo.status
			defaultData.detil = userInfo.detil

			return defaultData
		},

		canManageUser: (state) => {
			const userInfo = state.userInfo
			if (!userInfo) {
				return false
			}

			if (!userInfo.roleInfo) {
				return false
			}

			if (!userInfo.roleInfo.appsmanager) {
				return false
			}

			let roles = userInfo.roleInfo.appsmanager.map(e => e.role)
			return Array.isArray(roles) && roles.length > 0
		},

        roles: (state) => {
			const userInfo = state.userInfo
			console.log('userInfo: ', userInfo)

            if (!userInfo) {
				console.log("No userInfo!")
				return false
			}

            if (!userInfo.roleInfo) {
				console.log("user has no roleinfo!")
				return false
			}

			if (!userInfo.roleInfo.siroleg) {
				console.log("user has no siroleg auth")
				return false
			}

			return userInfo.roleInfo.siroleg.map(e => e.role)
            // return state.userInfo.apps_data['5'].roles.filter(e => -1 !== roles.indexOf(e))
        },
        version: (state) => (process.env.APP_VERSION),
        hasRole : (state, getters) => (roles) => {
            // special case
            if (roles === '*') {
                var arr_roles = getters.roles
                return Array.isArray(arr_roles)
            }

            // better check, split em
            var arr_roles = roles.split(',')
            var intersection = arr_roles.filter(e => getters.roles.indexOf(e.trim()) !== -1)

			// only true if there's a appsmanager requirement and it passes
			var passUserManagerCheck = arr_roles.filter(e => e.trim() == 'siroleg.usermanager') && getters.canManageUser

            return intersection.length > 0 || passUserManagerCheck
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js